// extracted by mini-css-extract-plugin
export default {"stack":"AvatarStack_stack__xAP2u","avatarWrap":"AvatarStack_avatarWrap__-voWS","overflowBadge":"AvatarStack_overflowBadge__RH5Xm"};